import router from '@/router'
import store from '@/store'
import localStore from 'store'

const initialState = () => ({
  id: '',
  title: '',
  file: '',
  playing: true,
  loading: false,
  fullscreen: false,
  timeline: {
    currentTime: 0,
    duration: 0,
    buffered: []
  },
  audio: {
    volume: 1,
    muted: false
  },
  playlistGroupData: {},
  playlistData: {}
})

const state = initialState()

const getters = {}

function getPlaylistGroupData(playlistId, playlistGroupId) {
  const playlistGroup = store.getters['contentTree/findPlaylistGroup'](playlistGroupId)
  if (!playlistGroup) {
    return
  }

  let index = 0
  for (; index < playlistGroup.playlists.length; index++) {
    if (playlistGroup.playlists[index] === playlistId) {
      break
    }
  }

  return {
    id: playlistGroupId,
    season: index + 1
  }
}

function getPlaylistData(videoId, playlistId) {
  const playlist = store.getters['contentTree/findPlaylist'](playlistId)
  if (!playlist) {
    return
  }

  let index = 0
  for (; index < playlist.playables.length; index++) {
    if (playlist.playables[index].contentId === videoId) {
      break
    }
  }

  const nextPlayable = playlist.playables[index + 1] || playlist.playables[0]
  return {
    id: playlistId,
    title: playlist.title,
    episode: index + 1,
    nextVideo: nextPlayable.contentId
  }
}

const actions = {
  next({ commit, state }) {
    const id = state.playlistData.nextVideo
    const playlistId = state.playlistData.id
    const playlistGroupId = state.playlistGroupData.id
    // const fullscreen = state.fullscreen

    // commit('RECREATE_STATE')
    // commit('SET_FULLSCREEN', fullscreen)
    router.replace({
      name: 'watch-video',
      params: { playlistGroupId, playlistId, id }
    })
  },
  load({ commit, dispatch, state }, { playlistGroupId, playlistId, id }) {
    const video = store.getters['contentTree/findVideo'](id)
    const playlistData = getPlaylistData(id, playlistId)
    const playlistGroupData = getPlaylistGroupData(playlistId, playlistGroupId)
    const fullscreen = state.fullscreen

    if (!playlistData || !playlistGroupData || !video) {
      return router.home(true)
    }

    commit('RECREATE_STATE')
    commit('SET_VIDEO', video)
    commit('SET_PLAYLIST_DATA', playlistData)
    commit('SET_PLAYLIST_GROUP_DATA', playlistGroupData)

    commit('SET_FULLSCREEN', fullscreen)
    dispatch('loadVolume')
  },
  trackEvents({ commit, dispatch }, { video, player }) {
    player.addEventListener('buffering', event => commit('SET_VIDEO_LOADING', event.buffering))
    video.addEventListener('waiting', () => commit('SET_VIDEO_LOADING', true))
    video.addEventListener('playing', () => commit('SET_VIDEO_LOADING', false))
    video.addEventListener('pause', () => commit('SET_VIDEO_PLAYING', false))
    video.addEventListener('play', () => commit('SET_VIDEO_PLAYING', true))
    video.addEventListener('timeupdate', event => commit('SET_CURRENT_TIME', event.target.currentTime))
    video.addEventListener('ended', () => dispatch('next'))
    video.addEventListener('progress', () => commit('SET_BUFFERED', player.getBufferedInfo().total))
  },
  toggle({ commit, state }) {
    commit('SET_VIDEO_PLAYING', !state.playing)
  },
  toggleMute({ commit, dispatch, state }) {
    commit('SET_VIDEO_MUTED', !state.audio.muted)

    dispatch('saveVolume')
  },
  changeVolume({ commit, dispatch }, volume) {
    const muted = volume === '0'

    commit('SET_VIDEO_VOLUME', volume)
    commit('SET_VIDEO_MUTED', muted)

    dispatch('saveVolume')
  },
  saveVolume({ state }) {
    localStore.set('playkids/video-volume', state.audio.volume)
    localStore.set('playkids/video-muted', state.audio.muted)
  },
  loadVolume({ commit }) {
    const volume = localStore.get('playkids/video-volume')
    const muted = localStore.get('playkids/video-muted')

    if (volume != null && muted != null) {
      commit('SET_VIDEO_VOLUME', volume)
      commit('SET_VIDEO_MUTED', muted)
    }
  },
  toggleFullscreen({ commit, state }) {
    commit('SET_FULLSCREEN', !state.fullscreen)
  }
}

const mutations = {
  RECREATE_STATE(state) {
    Object.assign(state, initialState())
  },
  SET_VIDEO(state, video) {
    state.id = video.id
    state.title = video.title
    state.file = video.file
  },
  SET_VIDEO_PLAYING(state, playing) {
    state.playing = playing
  },
  SET_VIDEO_LOADING(state, loading) {
    state.loading = loading
  },
  SET_VIDEO_MUTED(state, muted) {
    state.audio.muted = muted
  },
  SET_VIDEO_VOLUME(state, volume) {
    state.audio.volume = volume
  },
  SET_CURRENT_TIME(state, currentTime) {
    state.timeline.currentTime = currentTime
  },
  SET_DURATION(state, duration) {
    state.timeline.duration = duration
  },
  SET_BUFFERED(state, buffered) {
    state.timeline.buffered = buffered
  },
  SET_FULLSCREEN(state, fullscreen) {
    state.fullscreen = fullscreen
  },
  SET_PLAYLIST_DATA(state, playlistData) {
    state.playlistData = playlistData
  },
  SET_PLAYLIST_GROUP_DATA(state, playlistGroupData) {
    state.playlistGroupData = playlistGroupData
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
